import { render, staticRenderFns } from "./PushPrompt.vue?vue&type=template&id=0c6aa1e9"
import script from "./PushPrompt.vue?vue&type=script&lang=js"
export * from "./PushPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports